import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useStyles } from '../styles';
import NavigationDropdown, { NavigationOption } from 'modules/views/shared/NavigationDropdown';

export const ProjectHeader: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.header} data-testid="project-list-header">
      <p className={classes.title} data-testid="project-list-title">
        {t('projectList.title')}
      </p>
      <NavigationDropdown excludeOptions={[NavigationOption.MY_PROJECTS]} />
    </Box>
  );
};
